import { render, staticRenderFns } from "./define-ability.vue?vue&type=template&id=33a1de48"
import script from "./define-ability.vue?vue&type=script&lang=js"
export * from "./define-ability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33a1de48')) {
      api.createRecord('33a1de48', component.options)
    } else {
      api.reload('33a1de48', component.options)
    }
    module.hot.accept("./define-ability.vue?vue&type=template&id=33a1de48", function () {
      api.rerender('33a1de48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/define-ability.vue"
export default component.exports